export const TitleStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  color: "#333",
  fontFeatureSettings:"'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",  
  fontFamily: "FS Elliot Pro Bold",
  fontSize: "48px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "54px",
  letterSpacing: "-0.5px",
}

export const TextTitleStyle:React.CSSProperties = {
  alignSelf: "stretch",
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",  
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
}

export const TableTitleStyle:React.CSSProperties = {
  color: "#333",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'FS Elliot Pro Bold',
  fontSize: "40px",
  fontStyle: "normal",
  fontWeight: "300",
  lineHeight: "48px",
  letterSpacing: "-0.5px",
  flex: "1 0 0"
}

export const TableSubtitleStyle:React.CSSProperties = {
  color: "#333",
  fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
  fontFamily: 'FS Elliot Pro Bold',
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "36px",  
  flex: "1 0 0"
}

